import { useNavigate, useSearchParams } from "react-router-dom";
import { cardBorderClassName } from "../../lib/cardStyles";
import { getOrCreateOnboarding } from "../../lib/onboarding";

export default function OnboardingSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ob = getOrCreateOnboarding();

  const step2 = ob.step2 as Record<string, unknown> | undefined;
  const businessName = String(
    step2?.businessName ?? step2?.business_name ?? "your business",
  );
  const email = String(step2?.email ?? "");
  const plan = String(ob.plan || "starter");
  const clientReferenceId =
    params.get("client_reference_id") ||
    params.get("ref") ||
    (ob as Record<string, unknown>).clientReferenceId ||
    ob.sessionId ||
    "";

  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center px-6 py-16 text-white"
      style={{ background: "#0b0b10" }}
    >
      <div
        className="w-24 h-24 rounded-full flex items-center justify-center mb-8"
        style={{
          background: "rgba(34, 197, 94, 0.12)",
          border: "2px solid rgba(34, 197, 94, 0.5)",
          boxShadow: "0 0 40px rgba(34, 197, 94, 0.3)",
        }}
      >
        <i
          className="ri-check-line"
          style={{ fontSize: "48px", color: "rgb(74, 222, 128)" }}
        />
      </div>

      <h1
        className="text-5xl md:text-6xl font-bold mb-4 text-center"
        style={{
          fontFamily: "'Orbitron', sans-serif",
          background: "linear-gradient(135deg, #8a2be2 0%, #ff6a00 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Payment received.
      </h1>

      <p
        className="text-lg text-gray-300 text-center max-w-lg mb-8 leading-relaxed"
        style={{ fontFamily: "'Space Grotesk', sans-serif" }}
      >
        Thanks for choosing NeuroSphere for{" "}
        <span className="text-white font-semibold">{businessName}</span>.
        Next, choose a phone number for your receptionist.
      </p>

      <div
        className={`w-full max-w-md rounded-xl p-5 mb-10 ${cardBorderClassName}`}
        style={{ background: "rgba(13, 13, 18, 0.7)" }}
      >
        <p
          className="text-xs uppercase tracking-widest text-gray-500 mb-4"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          Activation reference
        </p>
        <dl className="space-y-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          {email ? (
            <div>
              <dt className="text-xs text-gray-500">Email</dt>
              <dd className="text-white text-sm">{email}</dd>
            </div>
          ) : null}
          <div>
            <dt className="text-xs text-gray-500">Plan</dt>
            <dd className="text-white text-sm capitalize">{plan}</dd>
          </div>
          {clientReferenceId ? (
            <div>
              <dt className="text-xs text-gray-500">Reference ID</dt>
              <dd className="text-white text-sm break-all">{String(clientReferenceId)}</dd>
            </div>
          ) : null}
        </dl>
      </div>

      <button
        type="button"
        onClick={() => navigate("/onboarding/choose-number")}
        className="px-8 py-4 rounded-xl text-base font-bold text-white cursor-pointer mb-5"
        style={{
          background: "linear-gradient(90deg, #8a2be2, #ff6a00)",
          fontFamily: "'Space Grotesk', sans-serif",
          boxShadow: "0 0 32px rgba(138, 43, 226, 0.4)",
        }}
      >
        Choose your number
      </button>

      <button
        type="button"
        onClick={() => navigate("/login")}
        className="text-sm text-purple-400 hover:text-purple-300 transition-colors cursor-pointer mb-6"
        style={{ fontFamily: "'Space Grotesk', sans-serif" }}
      >
        Log in
      </button>

      <p
        className="text-xs text-gray-500 text-center max-w-md"
        style={{ fontFamily: "'Space Grotesk', sans-serif" }}
      >
        Your account is saved. If search asks you to sign in, use the email you
        just registered.
      </p>
    </div>
  );
}
